import React, { useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, ChevronUp } from "lucide-react";
import Footer from "../index/Footer";
import Header from "../index/Header";


const faqs = [
    {
        question: "¿Cómo puedo reservar un evento personalizado?",
        answer: "Puedes contactarnos a través de nuestro formulario o redes sociales. Concertaremos una reunión para conocer tu idea y comenzar a diseñarla.",
    },
    {
        question: "¿Cuánto tiempo de antelación necesito para organizar un baile o celebración?",
        answer: "Lo ideal es contactarnos con al menos 3 meses de antelación para garantizar la personalización y logística completa.",
    },
    {
        question: "¿Ofrecéis alquiler de vestuario?",
        answer: "Sí, contamos con servicio de asesoría y alquiler de vestuario acorde a la temática del evento.",
    },
    {
        question: "¿Los eventos son solo en Sevilla?",
        answer: "No. Aunque estamos ubicadas en Sevilla, nos desplazamos por toda Andalucía según el tipo de evento.",
    },
    {
        question: "¿Es obligatorio ir disfrazado a los bailes?",
        answer: "No es obligatorio, pero sí muy recomendable para vivir la experiencia de forma completa. También podemos ayudarte a encontrar tu atuendo.",
    },
];

export default function FaqPage() {
    const [openIndex, setOpenIndex] = useState(null);

    const toggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const scrollRef = useRef();
    return (
        
            <div className="relative font-cinzel text-eryndra-cream bg-eryndra-forest bg-cover bg-center min-h-screen overflow-hidden py-10">

                
                <Header scrollRef={scrollRef} backgroundColor="bg-eryndra-forest/20" />
                <section className="bg-eryndra-forest min-h-screen text-eryndra-cream py-20 px-4 font-cinzel">
                    <div className="max-w-4xl mx-auto space-y-8">
                        <h1 className="text-4xl md:text-6xl text-center font-cinzel text-eryndra-gold uppercase tracking-wider mb-12">
                            Preguntas Frecuentes
                        </h1>

                        {faqs.map((faq, index) => (
                            <div
                                key={index}
                                className="border border-eryndra-gold rounded-lg overflow-hidden bg-eryndra-ivory/5 backdrop-blur-md shadow-lg"
                            >
                                <button
                                    onClick={() => toggle(index)}
                                    className="flex justify-between items-center w-full p-6 text-left"
                                >
                                    <span className="text-xl md:text-2xl font-semibold text-eryndra-gold">
                                        {faq.question}
                                    </span>
                                    {openIndex === index ? (
                                        <ChevronUp className="text-eryndra-gold w-6 h-6" />
                                    ) : (
                                        <ChevronDown className="text-eryndra-gold w-6 h-6" />
                                    )}
                                </button>

                                <AnimatePresence initial={false}>
                                    {openIndex === index && (
                                        <motion.div
                                            key="content"
                                            initial={{ height: 0, opacity: 0 }}
                                            animate={{ height: "auto", opacity: 1 }}
                                            exit={{ height: 0, opacity: 0 }}
                                            transition={{ duration: 0.3, ease: "easeInOut" }}
                                            className="px-6 pb-6 text-xl text-eryndra-cream font-bellefair"
                                        >
                                            {faq.answer}
                                        </motion.div>
                                    )}
                                </AnimatePresence>
                            </div>
                        ))}
                    </div>


                </section>
                <Footer />
            </div>

    );
}